export const updates = [
  { id: 1, date: '2026-07-31', tag: '上新', title: '《流浪地球3》导演剪辑版独家上线，新增30分钟未播片段', time: '2小时前' },
  { id: 2, date: '2026-07-30', tag: '热播', title: '暑期档爆款《封神第二部》全网首播，单日播放量突破8000万', time: '昨天' },
  { id: 3, date: '2026-07-29', tag: '推荐', title: '豆瓣9.2分神作《奥本海默》4K修复版限时免费，画质全面升级', time: '2天前' },
  { id: 4, date: '2026-07-28', tag: '剧集', title: '《庆余年3》全40集一次性放出，范闲归来引爆追剧热潮', time: '3天前' },
  { id: 5, date: '2026-07-27', tag: '动漫', title: '国漫之光《深海》加长版上线，新增10分钟隐藏结局', time: '4天前' },
  { id: 6, date: '2026-07-26', tag: '综艺', title: '《奔跑吧》第十二季收官特辑上线，跑男家族告别演唱会完整版', time: '5天前' },
  { id: 7, date: '2026-07-25', tag: '独家', title: '韩国现象级悬疑片《破墓》中文配音版牛牛影视全网独家首播', time: '6天前' },
  { id: 8, date: '2026-07-24', tag: '榜单', title: '七月观影指南发布：本月最值得看的十部新片合集已整理完毕', time: '7天前' },
];

export const features = [
  { id: 1, icon: 'ri-movie-2-line', title: '片库全免费', desc: '收录超过12万部电影、电视剧、综艺、动漫、纪录片，全站免费无需会员，想怎么看就怎么看。' },
  { id: 2, icon: 'ri-speed-up-line', title: '高清不缓冲', desc: '全线路支持1080P和4K画质，多CDN智能调度，无论宽带还是移动网络都能秒加载不卡顿。' },
  { id: 3, icon: 'ri-calendar-check-line', title: '日更不重样', desc: '每日更新超过200部正版授权内容，热门新片同步院线，追剧日历帮你不错过任何一部好片。' },
];

export const appEntry = {
  title: '牛牛影视 App',
  subtitle: '随时随地，高清追剧',
  desc: '支持 iOS 与 Android，离线缓存、投屏观看、画中画模式，体验比网页版更流畅的观影方式。新用户注册即送7天VIP体验。',
  badge: 'V5.2.0 全新版本',
};

export const topics = [
  { id: 1, name: '流浪地球3', heat: '9.8万讨论', color: 'bg-primary-500' },
  { id: 2, name: '庆余年3', heat: '8.6万讨论', color: 'bg-accent-500' },
  { id: 3, name: '封神第二部', heat: '7.3万讨论', color: 'bg-primary-500' },
  { id: 4, name: '狂飙2', heat: '12.1万讨论', color: 'bg-accent-500' },
  { id: 5, name: '哪吒之魔童闹海', heat: '6.8万讨论', color: 'bg-primary-500' },
  { id: 6, name: '奥本海默', heat: '5.4万讨论', color: 'bg-accent-500' },
  { id: 7, name: '一念关山', heat: '4.9万讨论', color: 'bg-primary-500' },
  { id: 8, name: '三体电视剧', heat: '8.2万讨论', color: 'bg-accent-500' },
  { id: 9, name: '奔跑吧12', heat: '8.2万讨论', color: 'bg-primary-500' },
  { id: 10, name: '深海', heat: '3.7万讨论', color: 'bg-accent-500' },
  { id: 11, name: '八角笼中', heat: '4.5万讨论', color: 'bg-primary-500' },
];

export const mediaCards = [
  {
    id: 1,
    title: '流浪地球3 幕后特辑',
    desc: '郭帆导演亲自解读太阳氦闪危机设定，揭秘数字生命计划背后的科学逻辑与视觉特效制作幕后故事。',
    duration: '48:32',
    views: '256万',
    category: '独家幕后',
  },
  {
    id: 2,
    title: '封神第二部 主创访谈',
    desc: '乌尔善导演携费翔、黄渤、于适等主创畅谈封神宇宙构建，分享殷郊复活与闻仲大军的拍摄趣事。',
    duration: '32:15',
    views: '189万',
    category: '明星专访',
  },
  {
    id: 3,
    title: '2026暑期档观影指南',
    desc: '盘点暑期档最值得期待的15部大片，从科幻巨制到温情喜剧，一份清单帮你规划整个夏天的观影安排。',
    duration: '15:40',
    views: '432万',
    category: '观影指南',
  },
];

export const aboutData = {
  title: '关于牛牛影视',
  paragraphs: [
    '牛牛影视创立于2020年，致力于打造国内领先的免费高清影视聚合平台。我们深知观众对优质内容的渴望，因此持续拓展正版片源合作，目前已收录超过12万部影视作品，涵盖电影、电视剧、综艺、动漫、纪录片等多种类型。',
    '平台采用智能CDN分发技术，在全国部署超过300个加速节点，确保用户无论身处何地都能享受流畅不缓冲的观影体验。内容团队每日精选热门新片与经典老片，配合个性化推荐算法，让每位用户都能快速找到自己想看的内容。',
    '牛牛影视始终坚持"免费不降质"的理念，所有内容均可免费观看，无需注册会员、无需付费解锁。我们相信，好的内容应该被更多人看到，这是牛牛影视不变的初心。',
  ],
  stats: [
    { value: '12万+', label: '影视资源' },
    { value: '3000万+', label: '月活用户' },
    { value: '200+', label: '日更新量' },
    { value: '99.7%', label: '播放成功率' },
  ],
};

export const faqItems = [
  {
    id: 1,
    question: '牛牛影视真的完全免费吗？需要注册会员吗？',
    answer: '是的，牛牛影视全站内容完全免费，无需注册、无需登录、无需付费即可观看所有影视内容。我们通过广告收入维持运营，绝不会设置付费墙或会员门槛。观看过程中如果遇到广告，关闭后即可继续正常观影，不影响观影体验。',
  },
  {
    id: 2,
    question: '视频画质如何？支持哪些清晰度？',
    answer: '平台主力提供1080P高清画质，热播内容同步上线4K超清版本。播放器支持根据您的网络状况自动切换清晰度，也支持手动选择流畅、高清、超清、蓝光等多个档位。同时支持画中画模式和投屏功能，方便在大屏设备上观看。',
  },
  {
    id: 3,
    question: '更新速度怎么样？热门新片什么时候能看？',
    answer: '我们的内容团队每日更新超过200部作品，热门院线电影通常在影院上映后30-60天内上线高清版本。热门电视剧则基本保持与播出平台同步更新，大部分剧集在电视台播出后24小时内即可在牛牛影视观看。',
  },
  {
    id: 4,
    question: '手机端可以观看吗？有没有App？',
    answer: '牛牛影视全面适配移动端浏览器，手机访问自动切换移动版界面，触屏操作流畅。同时我们提供iOS和Android原生App下载，App支持离线缓存功能，下载后无网络也能观看，通勤旅行追剧更方便。',
  },
];

export const cards = [
  { id: 1, title: '科幻巨制推荐：未来已来', desc: '从《流浪地球》系列到《三体》，中国科幻电影的黄金时代已经到来', tag: '科幻', imgSeq: 'scifi-movies' },
  { id: 2, title: '悬疑烧脑片单：挑战智商', desc: '15部让你看完怀疑人生的高能悬疑片，每一部都经得起反复推敲', tag: '悬疑', imgSeq: 'thriller-movies' },
  { id: 3, title: '国漫崛起：不可错过的佳作', desc: '从《哪吒》到《深海》，国漫用实力证明中国动画的世界级水准', tag: '国漫', imgSeq: 'anime-movies' },
  { id: 4, title: '暑期亲子观影指南', desc: '精选适合全家人一起看的20部电影，寓教于乐陪伴孩子成长', tag: '亲子', imgSeq: 'family-movies' },
  { id: 5, title: '港片经典回顾：黄金年代', desc: '重温香港电影黄金时代的经典之作，那些年我们追过的港片', tag: '港片', imgSeq: 'hk-movies' },
  { id: 6, title: '高分纪录片：看见真实世界', desc: '10部改变人生观的纪录片，带你看见这个世界不一样的一面', tag: '纪录片', imgSeq: 'documentary' },
  { id: 7, title: '韩剧入坑指南：从零开始', desc: '从《黑暗荣耀》到《破墓》，韩流影视入门必看的精选片单', tag: '韩剧', imgSeq: 'korean-drama' },
];

export const indexItems = [
  { id: 1, name: '动作片', count: '3,826部', icon: 'ri-sword-line' },
  { id: 2, name: '喜剧片', count: '2,941部', icon: 'ri-emotion-laugh-line' },
  { id: 3, name: '爱情片', count: '3,152部', icon: 'ri-heart-line' },
  { id: 4, name: '科幻片', count: '1,876部', icon: 'ri-rocket-line' },
  { id: 5, name: '恐怖片', count: '1,543部', icon: 'ri-ghost-line' },
  { id: 6, name: '国产剧', count: '4,210部', icon: 'ri-tv-line' },
  { id: 7, name: '韩剧', count: '1,987部', icon: 'ri-kakao-talk-line' },
  { id: 8, name: '综艺', count: '2,634部', icon: 'ri-mic-line' },
  { id: 9, name: '动漫', count: '5,128部', icon: 'ri-ancient-gate-line' },
];

export const comments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20casual%20style%20warm%20lighting%20simple%20background%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '追剧小达人',
    time: '3天前',
    content: '用了三年牛牛影视了，片源真的全，更新也快。最近在追庆余年3，周日晚上电视台播完周一早上这里就有了，太给力了！画质也很稳定，推荐给身边所有朋友了。',
    rating: 5,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20friendly%20smile%20casual%20style%20warm%20lighting%20simple%20background%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '电影发烧友阿杰',
    time: '5天前',
    content: '作为一个每周看3-4部电影的人，牛牛影视的分类和推荐真的很懂我。科幻片和悬疑片的片单质量很高，很多冷门好片在这里都能找到。最满意的是没有乱七八糟的弹窗广告。',
    rating: 5,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20fresh%20look%20warm%20lighting%20simple%20background%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '周末宅家星人',
    time: '1周前',
    content: '周末唯一的快乐就是躺在沙发上用牛牛影视投屏到电视上看电影。最近在补漫威全系列，画质投到65寸电视上也很清晰。免费的能做到这个水平真的超出预期了！',
    rating: 4,
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '流浪地球3 深度解读',
    subtitle: '数字生命 vs 流浪派：人类文明的终极抉择',
    desc: '郭帆导演用三部曲构建了一个完整的未来世界观。从刹车时代到逃逸时代，再到太阳氦闪危机，流浪地球系列不仅是中国科幻的里程碑，更引发了对人类命运共同体的深层思考。本文深度解析电影中的科学设定、哲学隐喻与视觉美学。',
    category: '深度解读',
    date: '2026-07-30',
  },
  {
    id: 2,
    title: '2026暑期档：神仙打架',
    subtitle: '15部大片扎堆上映，这个夏天看什么？',
    desc: '从国产科幻巨制到好莱坞视效大片，从温情动画到硬核悬疑，今年暑期档堪称近年来最强阵容。我们整理了最值得期待的15部影片排期，附上映时间和看点分析，帮你合理规划这个夏天的电影票预算。',
    category: '观影指南',
    date: '2026-07-28',
  },
  {
    id: 3,
    title: '国漫十年：从边缘到中心',
    subtitle: '中国动画如何用十年时间完成逆袭',
    desc: '从《大圣归来》点燃希望，到《哪吒之魔童降世》创造票房奇迹，再到《深海》以极致美学惊艳世界。国漫用十年时间完成了从"低幼代名词"到"文化输出主力军"的华丽蜕变。本文回顾这段激动人心的崛起之路。',
    category: '行业观察',
    date: '2026-07-25',
  },
  {
    id: 4,
    title: '悬疑片爱好者必修课',
    subtitle: '从希区柯克到奉俊昊：悬疑电影的进化史',
    desc: '悬疑片是最考验导演功力的类型之一。本专题横跨百年电影史，从经典好莱坞时期的黑色电影，到韩国悬疑片的新浪潮崛起，再到近年国产悬疑的爆发，梳理悬疑电影的美学流变与叙事创新。',
    category: '影史回顾',
    date: '2026-07-22',
  },
];

export const contactData = {
  title: '联系我们',
  subtitle: '意见反馈 / 内容推荐 / 商务合作',
  desc: '如果您有影片推荐、内容反馈或商务合作需求，欢迎通过以下方式与我们取得联系。我们重视每一条用户建议，会尽快回复您。',
  email: 'feedback@niuniuys.com',
  wechat: 'niuniu_movie',
  qqGroup: '836290174',
};

export const rankingItems = [
  { id: 1, rank: 1, title: '流浪地球3', category: '科幻', hot: '9.8', trend: 'up', desc: '太阳氦闪危机降临，人类文明面临终极考验' },
  { id: 2, rank: 2, title: '庆余年3', category: '古装', hot: '9.5', trend: 'up', desc: '范闲布局天下，庆国风云再起' },
  { id: 3, rank: 3, title: '封神第二部', category: '奇幻', hot: '9.2', trend: 'up', desc: '殷郊复活归来，闻仲大军兵临城下' },
  { id: 4, rank: 4, title: '狂飙2', category: '犯罪', hot: '9.0', trend: 'new', desc: '扫黑除恶再掀波澜，安欣高启强命运交织' },
  { id: 5, rank: 5, title: '奥本海默', category: '传记', hot: '8.7', trend: 'up', desc: '原子弹之父的荣耀与挣扎，诺兰封神之作' },
];

export const navLinks = [
  { label: '焦点专题', href: '#carousel' },
  { label: '热门榜单', href: '#ranking' },
  { label: '最新快讯', href: '#updates' },
  { label: '联系我们', href: '#contact' },
  { label: '下载App', href: '#app' },
];

export const footerPartners = [
  '合作伙伴（排名不分先后）',
  '虚位以待',
  '虚位以待',
  '虚位以待',
  '虚位以待',
  '虚位以待',
  '虚位以待',
  '虚位以待',
];